import styled from 'styled-components';
import { Button } from 'reactstrap';

import { BREAKPOINTS, useBreakpointSize } from '../../../utils/responsive';

const DROP_SHADOW = 'box-shadow: 2px 2px 4px 2px rgb(0 0 0 / 20%);';

export const MainContainer = styled.div`
  position: relative;

  height: 100vh; // fallback
  height: 100dvh;

  width: 100vw;
  max-width: 1800px;

  margin: 0 auto;
  overflow: hidden;

  display: flex;

  flex-direction: column;
  @media (min-width: ${BREAKPOINTS.lg}) {
    flex-direction: row;
    max-height: 1200px;
  }

  background-color: white;

  /* class for buttons on map to make them match the cards better */
  .map-button {
    ${DROP_SHADOW}
    background-color: #fff !important;
    font-size: 15.6px;

    width: fit-content;
  }
`;

export const FullOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(64, 64, 64, 0.75);
  z-index: 1001;

  display: flex;
  justify-content: center;
  align-items: center;
`;

// styles to match reactstrap buttons, plus drop shadow + more padding
const CardBase = styled.div`
  color: #212529;
  background-color: #fff;
  border-color: var(--border-color);
  border-radius: 3px;

  padding: 16px;

  ${DROP_SHADOW}
`;

export const LoadingCard = styled(CardBase)`
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 32px);
  text-align: center;

  width: 300px;
  padding: 16px;
  font-size: 15.6px;

  @media (min-width: ${BREAKPOINTS.md}) {
    width: 420px;
    padding: 24px;
    font-size: 20px;
  }
`;

export const PromptCard = styled(CardBase)`
  max-width: calc(100vw - 32px);
  text-align: center;

  width: 380px;
  padding: 16px;
  font-size: 15.6px;

  @media (min-width: ${BREAKPOINTS.md}) {
    width: 480px;
    padding: 24px;
    font-size: 20px;
  }
`;

export const InfoCard = styled(CardBase)`
  font-size: 15.6px;
`;

export const InfoText = styled.div`
  color: white;
  text-shadow: 0 0 16px rgb(0 0 0 / 50%);
  text-align: center;

  font-size: 18px;
  padding: 0 16px 12px;
  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 20px;
    padding: 0 16px 16px;
  }
  @media (min-width: ${BREAKPOINTS.lg}) {
    font-size: 26px;
  }
`;

// Add xs size to reactstrap Button
const ButtonWithXs = styled(Button)`
  &.btn-xs {
    padding: 2px 6px;
    font-size: 12px;

    @media (min-width: ${BREAKPOINTS.xs}) {
      font-size: 13px;
    }
  }
`;

/**
 * Extension of reactstrap Button with responsive sizing.
 *
 * Pass `sizes`, an array of strings, e.g. ['xs', 'sm', 'md', 'lg'], to specify
 * which sizes can be used.
 */
export const ResponsiveButton = ({ sizes = ['sm', 'md', 'lg'], ...props }) => {
  const size = useBreakpointSize(sizes);
  return <ButtonWithXs {...props} size={size} />;
};

export const DemoMapBackground = () => (
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage:
        "url('/images/public-suitability-tool-init-background.jpg')",
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
    }}
  />
);

export const LinkNewTab = ({ href, children }) => (
  <a href={href} target="_blank" rel="noreferrer">
    {children}
  </a>
);
